import {Component, OnDestroy} from '@angular/core';
import {EventAnalysisStoreService} from "../../store/event-analysis-store.service";
import {TimeRepository} from "../../repositories/core/time-repository/time-repository";
import {EmploymentCostsRepository} from "../../repositories/core/employment-costs/employment-costs-repository";
import {SalesDto, SalesDtoKeys} from "../../models/sales/sales-dto";
import {FilterVO} from "../../../common/utils/filter/models/filter-vo";
import {Subscription} from "rxjs";
import {Flow, SankeyController} from 'chartjs-chart-sankey';
import {Chart} from 'chart.js/auto';
import {FilterKeys} from "../../../common/utils/filter/enums/filter-keys";
import {LinkedDtoRepository} from "../../../common/repositories/linked-dto-repository";
import {ColorMapService} from "../../../common/colors/color-map.service";
import {SalesRepository} from "../../repositories/core/sales-repository/sales-repository";
import {TopSalesCardComponent} from "../../components/grids/top-sales-card/top-sales-card.component";
import {
  CompositionOverviewTableComponent
} from "../../components/table/composition-overview-table/composition-overview-table.component";
import {SankeyChartComponent} from "../../components/charts/sankey-chart/sankey-chart.component";
import {DistributionChartComponent} from "../../components/charts/distribution-chart/distribution-chart.component";
import {
  RevenueTimelineChartComponent
} from "../../components/charts/revenue-timeline-chart/revenue-timeline-chart.component";
import {SwitchComponent} from "../../../../x-components/switch/switch.component";
import {CommonModule, CurrencyPipe, DatePipe} from "@angular/common";
import {FormsModule} from "@angular/forms";

Chart.register(SankeyController, Flow);

@Component({
  selector: 'app-detailed-event-analysis',
  templateUrl: './detailed-event-analysis.component.html',
  styleUrls: ['./detailed-event-analysis.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    TopSalesCardComponent,
    CompositionOverviewTableComponent,
    SankeyChartComponent,
    DistributionChartComponent,
    RevenueTimelineChartComponent,
    SwitchComponent,
    CurrencyPipe,
    DatePipe
  ],
  providers: [
    EventAnalysisStoreService,
    // Common
    LinkedDtoRepository,
    ColorMapService,
    // Stores
    TimeRepository,
    SalesRepository,
    EmploymentCostsRepository,
  ]
})
export class DetailedEventAnalysisComponent implements OnDestroy {
  selectedOverviewGroupAttribute: keyof SalesDto = SalesDtoKeys.locationId;
  overviewGroupAttributes = [
    {key: SalesDtoKeys.locationId, description: "Umsatz pro Standort"},
    {key: SalesDtoKeys.compositionTypeId, description: "Umsatz pro Artikelkategorie"},
    {key: SalesDtoKeys.bookingType, description: "Umsatz pro Zahlungsmethode"}
  ]
  isNetRevenue: boolean = false;
  isSourceDetailsCostExcluded: boolean = false;
  isEmployeeSalesExcludedAndEmployeeSalesSourceDetailsIncluded: boolean = false;
  excludeEmployeeSales: boolean = false;
  subscription: Subscription = new Subscription();
  protected readonly SalesDtoKeys = SalesDtoKeys;

  constructor(public eventAnalysisStore: EventAnalysisStoreService,
              public employmentCostRepository: EmploymentCostsRepository
  ) {
    this.subscribeToStore()
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  subscribeToStore() {
    this.subscription.add(this.eventAnalysisStore.initializedNotifier.subscribe(() => {
        this.selectedOverviewGroupAttribute = this.overviewGroupAttributes[0].key;
      }
    ))
  }

  isNetRevenueChanged(event: boolean) {
    this.isNetRevenue = event;
    this.revenueCalculationChanged();
  }

  isSourceDetailsCostExcludedChanged(event: boolean) {
    this.isSourceDetailsCostExcluded = event;
    this.revenueCalculationChanged();
  }

  revenueCalculationChanged() {
    this.eventAnalysisStore.setRevenueCalculationMethodOption(this.isNetRevenue, this.isSourceDetailsCostExcluded)
  }

  excludeEmployeeSalesChanged(event: boolean) {
    this.excludeEmployeeSales = event;
    let filterVO: FilterVO<number> = new FilterVO(FilterKeys.BookingType, 2);
    if (event) {
      this.eventAnalysisStore.addFilter(filterVO)
    } else {
      this.eventAnalysisStore.removeFilter(filterVO)
    }

    this.eventAnalysisStore.update()
  }

  excludeEmployeeSalesAndKeepSourceDetailCost(event: boolean) {
    this.isEmployeeSalesExcludedAndEmployeeSalesSourceDetailsIncluded = event
    this.eventAnalysisStore.swapZeroRevenueSet(this.isEmployeeSalesExcludedAndEmployeeSalesSourceDetailsIncluded)
  }

  changeOverviewGroupAttribute(attribute: keyof SalesDto) {
    this.selectedOverviewGroupAttribute = attribute;
    this.eventAnalysisStore.setCurrentAttributeOption(attribute)

  }

  // Todo: auslagern in Utils
  dateToString(start: Date | undefined, end: Date | undefined) {
    if (start === undefined || end === undefined) return "";
    if (start.getDate() === end.getDate() && start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
      return start.toLocaleDateString('default', {day: '2-digit', month: 'long', year: 'numeric'})
    }

    return start.toLocaleDateString('default', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    }) + " - " + end.toLocaleDateString('default', {day: '2-digit', month: 'long', year: 'numeric'})
  }
}

//
